import { useEffect } from 'react';

type UsePreventScroll = (disabled?: boolean) => void;

const usePreventScroll: UsePreventScroll = (disabled = false) => {
  useEffect(() => {
    if (disabled) {
      return;
    }
    document.body.style.cssText = 'overflow:hidden';
    return () => {
      document.body.style.cssText = 'overflow:unset';
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default usePreventScroll;
